import React, { useState } from "react";
import './Menu.css';

function Menu() {
    const [activeTab, setActiveTab] = useState('midi');

    return (
        <div className="menu-page">

            {/* ── En-tête ──────────────────────────────────────────── */}
            <div className="menu-hero">
                <span className="menu-eyebrow">Découvrez</span>
                <h1 className="menu-title">
                    Nos <em>formules</em>
                </h1>
                <div className="menu-divider" />
                <p className="menu-subtitle">
                    Des menus pensés pour vous offrir le meilleur de notre cuisine,
                    midi et soir, au fil des saisons.
                </p>
            </div>

            {/* ── Onglets ──────────────────────────────────────────── */}
            <div className="menu-tabs-wrapper">
                <div className="menu-tabs">
                    <button
                        className={`menu-tab${activeTab === 'midi' ? ' active' : ''}`}
                        onClick={() => setActiveTab('midi')}
                    >
                        <span className="menu-tab-icon">☀</span>
                        Formule du midi
                    </button>
                    <button
                        className={`menu-tab${activeTab === 'soir' ? ' active' : ''}`}
                        onClick={() => setActiveTab('soir')}
                    >
                        <span className="menu-tab-icon">☽</span>
                        Formule du soir
                    </button>
                </div>
            </div>

            {/* ── Contenu menu ─────────────────────────────────────── */}
            <div className="menu-content">

                {/* Panneau midi */}
                <div className={`menu-panel${activeTab === 'midi' ? ' active' : ''}`}>
                    <div className="menu-panel-inner">
                        <div className="menu-panel-label">
                            <span className="menu-panel-number">01</span>
                            <div>
                                <span className="menu-panel-tag">Disponible le midi</span>
                                <p className="menu-panel-hours">Mardi – Vendredi · 12h – 13h45</p>
                            </div>
                        </div>
                        <div className="menu-image-frame">
                            <img src="/images/menu/menu-midi.jpg" alt="Menu du midi" className="menu-image" />
                            <div className="menu-image-overlay" />
                        </div>
                    </div>
                </div>

                {/* Panneau soir */}
                <div className={`menu-panel${activeTab === 'soir' ? ' active' : ''}`}>
                    <div className="menu-panel-inner">
                        <div className="menu-panel-label">
                            <span className="menu-panel-number">02</span>
                            <div>
                                <span className="menu-panel-tag">Disponible le soir</span>
                                <p className="menu-panel-hours">Jeudi – Samedi · 19h – 20h45</p>
                            </div>
                        </div>
                        <div className="menu-image-frame">
                            <img src="/images/menu/menu-soir.jpg" alt="Menu du soir" className="menu-image" />
                            <div className="menu-image-overlay" />
                        </div>
                    </div>
                </div>

            </div>

            {/* ── CTA Réservation ──────────────────────────────────── */}
            <div className="menu-cta-section">
                <p className="menu-cta-text">
                    Une question sur nos formules ? Nous sommes à votre écoute.
                </p>
                <a
                    href="https://bookings.zenchef.com/results?rid=379037&pid=1001"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="menu-cta-btn"
                >
                    Réserver une table
                    <span className="menu-cta-arrow" />
                </a>
            </div>

        </div>
    );
}

export default Menu;
